document.addEventListener('DOMContentLoaded', () => {
  const countryQuantityLimitModal = document.querySelector('.country-quantity-limit--modal');
  if (countryQuantityLimitModal != null) {
    const countryQuantityLimitModalButton = countryQuantityLimitModal.querySelector('.button');
    countryQuantityLimitModalButton.addEventListener('click', (e) => {
      e.preventDefault();

      countryQuantityLimitModal.remove();
    });

    const quantityFields = document.querySelectorAll('.product-quantity');
    if (quantityFields.length > 0) {
      quantityFields.forEach((quantityField) => {
        const quantityFieldNumber = quantityField.querySelector('[name="quantity"]');
        const quantityFieldNumberLimit = quantityFieldNumber.getAttribute('data-limit');

        if (quantityFieldNumberLimit != null) {
          const quantityFieldPlus = quantityField.querySelector('.product-quantity__plus');
          const quantityFieldNumberValue = quantityFieldNumber.value;

          quantityFieldNumber.addEventListener('change', (e) => {
            const field = e.currentTarget;
            if (parseInt(field.value) >= parseInt(quantityFieldNumberLimit)) {
              const countryQuantityLimitModalEl = document.querySelector('.country-quantity-limit--modal');
              if (countryQuantityLimitModalEl != null) {
                countryQuantityLimitModalEl.classList.remove('hidden');
              }
            }
          });
          
          quantityFieldPlus.addEventListener('click', (e) => {
            if (parseInt(quantityFieldNumberValue) >= parseInt(quantityFieldNumberLimit)) {
              const countryQuantityLimitModalEl = document.querySelector('.country-quantity-limit--modal');
              if (countryQuantityLimitModalEl != null) {
                countryQuantityLimitModalEl.classList.remove('hidden');
              }
            }
          });
        }
      });
    }
  }
});
